/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  UpdateProfileMutationRequest,
  UpdateProfileMutationResponse,
  UpdateProfile401,
} from "../types/UpdateProfile.ts"
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query"
import { updateProfile } from "../client/updateProfile.ts"
import { useMutation } from "@tanstack/react-query"

export const updateProfileMutationKey = () => [{ url: "/me/profile" }] as const

export type UpdateProfileMutationKey = ReturnType<
  typeof updateProfileMutationKey
>

/**
 * @summary Update your profile
 * {@link /me/profile}
 */
export function useUpdateProfile<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateProfileMutationResponse,
      ResponseErrorConfig<UpdateProfile401>,
      { data: UpdateProfileMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<UpdateProfileMutationRequest>> & {
      client?: typeof fetch
    }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateProfileMutationKey()

  return useMutation<
    UpdateProfileMutationResponse,
    ResponseErrorConfig<UpdateProfile401>,
    { data: UpdateProfileMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return updateProfile(data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}
